function TitleBanner({
  title = "Quaggan Wheel",
  subtitle,
  leftGif,
  rightGif,
  bobbing = true,
}) {
  const showSubtitle = Boolean(subtitle);

  return (
    <div className="qw-banner">
      <div className="qw-banner-inner" />

      {/* Sparkles */}
      <div className="qw-sparkle qw-s1">✦</div>
      <div className="qw-sparkle qw-s2">✧</div>
      <div className="qw-sparkle qw-s3">✦</div>
      <div className="qw-sparkle qw-s4">✧</div>
      <div className="qw-sparkle qw-s5">✦</div>
      <div className="qw-sparkle qw-s6">✧</div>

      {/* Rising bubbles */}
      <div className="qw-bubble qw-b1" />
      <div className="qw-bubble qw-b2" />
      <div className="qw-bubble qw-b3" />
      <div className="qw-bubble qw-b4" />

      {/* Left quaggan */}
      <div className={`qw-ql${bobbing ? " qw-ql-bob" : ""}`}>
        {leftGif ? (
          <img
            src={leftGif}
            alt="left quaggan"
            style={{ width: 120, height: 138, objectFit: "contain", display: "block" }}
          />
        ) : (
          <svg viewBox="0 0 180 210" xmlns="http://www.w3.org/2000/svg" width="120" height="138">
            <defs>
              <radialGradient id="qw-pg" cx="36%" cy="42%" r="60%">
                <stop offset="0%" stopColor="#c070ff" />
                <stop offset="100%" stopColor="#6010c0" />
              </radialGradient>
              <radialGradient id="qw-pb" cx="50%" cy="48%" r="52%">
                <stop offset="0%" stopColor="#ddb0ff" />
                <stop offset="100%" stopColor="#a050e0" />
              </radialGradient>
            </defs>
            <g className="qw-sway-l">
              <g className="qw-wag-l" style={{ transformOrigin: "105px 158px" }}>
                <ellipse
                  cx="122" cy="156" rx="32" ry="11"
                  fill="#4a08a0" stroke="#30006a" strokeWidth="2"
                  transform="rotate(-10,122,156)"
                />
              </g>

              <ellipse cx="62" cy="188" rx="20" ry="9" fill="#5010a8" stroke="#30006a" strokeWidth="2" transform="rotate(-5,62,188)" />
              <ellipse cx="100" cy="188" rx="20" ry="9" fill="#5010a8" stroke="#30006a" strokeWidth="2" transform="rotate(5,100,188)" />

              <path
                d="M 80,48 C 106,48 128,62 136,86 C 144,112 142,148 132,168 C 120,186 102,198 80,198 C 58,198 40,186 28,168 C 18,148 16,112 24,86 C 32,62 54,48 80,48 Z"
                fill="url(#qw-pg)" stroke="#4a10a0" strokeWidth="2.5"
              />
              <ellipse cx="80" cy="138" rx="36" ry="54" fill="url(#qw-pb)" opacity="0.5" />
              <ellipse cx="58" cy="70" rx="16" ry="10" fill="rgba(255,225,255,0.28)" transform="rotate(-22,58,70)" />

              <g className="qw-fla" style={{ transformOrigin: "18px 122px" }}>
                <ellipse cx="18" cy="122" rx="15" ry="9" fill="#8030d8" stroke="#4a10a0" strokeWidth="2" />
              </g>
              <g className="qw-flb" style={{ transformOrigin: "142px 118px" }}>
                <ellipse cx="142" cy="118" rx="15" ry="9" fill="#8030d8" stroke="#4a10a0" strokeWidth="2" />
              </g>

              <g className="qw-blnk" style={{ transformOrigin: "60px 106px" }}>
                <circle cx="60" cy="106" r="8" fill="#100020" stroke="#06000e" strokeWidth="1.5" />
                <circle cx="57" cy="102" r="2.6" fill="white" opacity="0.9" />
              </g>
              <g className="qw-blnk" style={{ transformOrigin: "100px 106px", animationDelay: "0.15s" }}>
                <circle cx="100" cy="106" r="8" fill="#100020" stroke="#06000e" strokeWidth="1.5" />
                <circle cx="97" cy="102" r="2.6" fill="white" opacity="0.9" />
              </g>

              <path d="M52,124 Q80,148 108,124" fill="#0e001e" />
              <path d="M55,126 Q80,144 105,126" fill="#ff60a0" opacity="0.85" />
              <path d="M52,124 Q80,148 108,124" fill="none" stroke="#0e001e" strokeWidth="2.5" strokeLinecap="round" />
            </g>
          </svg>
        )}
      </div>

      {/* Right quaggan (mirrored blue) */}
      <div className={`qw-qr${bobbing ? " qw-qr-bob" : ""}`}>
        {rightGif ? (
          <img
            src={rightGif}
            alt="right quaggan"
            style={{ width: 115, height: 134, objectFit: "contain", display: "block" }}
          />
        ) : (
          <svg viewBox="0 0 180 210" xmlns="http://www.w3.org/2000/svg" width="115" height="134">
            <defs>
              <radialGradient id="qw-bg" cx="64%" cy="42%" r="60%">
                <stop offset="0%" stopColor="#70d0ff" />
                <stop offset="100%" stopColor="#0e50b8" />
              </radialGradient>
              <radialGradient id="qw-bb" cx="50%" cy="48%" r="52%">
                <stop offset="0%" stopColor="#f2faff" />
                <stop offset="100%" stopColor="#b8d8f0" />
              </radialGradient>
            </defs>
            <g transform="translate(180,0) scale(-1,1)">
              <g className="qw-sway-r">
                <g className="qw-wag-r" style={{ transformOrigin: "105px 155px" }}>
                  <ellipse
                    cx="122" cy="153" rx="32" ry="11"
                    fill="#0640a0" stroke="#042870" strokeWidth="2"
                    transform="rotate(-10,122,153)"
                  />
                </g>

                <ellipse cx="62" cy="188" rx="20" ry="9" fill="#0848a8" stroke="#042870" strokeWidth="2" transform="rotate(-5,62,188)" />
                <ellipse cx="100" cy="188" rx="20" ry="9" fill="#0848a8" stroke="#042870" strokeWidth="2" transform="rotate(5,100,188)" />

                <path
                  d="M 80,48 C 106,48 128,62 136,86 C 144,112 142,148 132,168 C 120,186 102,198 80,198 C 58,198 40,186 28,168 C 18,148 16,112 24,86 C 32,62 54,48 80,48 Z"
                  fill="url(#qw-bg)" stroke="#0848a0" strokeWidth="2.5"
                />
                <ellipse cx="80" cy="138" rx="34" ry="52" fill="url(#qw-bb)" opacity="0.55" />
                <circle cx="104" cy="64" r="8" fill="#50b8f8" opacity="0.32" />
                <circle cx="118" cy="80" r="5" fill="#50b8f8" opacity="0.24" />
                <ellipse cx="104" cy="66" rx="16" ry="10" fill="rgba(215,248,255,0.32)" transform="rotate(20,104,66)" />

                <g className="qw-fla" style={{ transformOrigin: "18px 120px" }}>
                  <ellipse cx="18" cy="120" rx="14" ry="9" fill="#1878d0" stroke="#0848a0" strokeWidth="2" />
                </g>
                <g className="qw-flb" style={{ transformOrigin: "142px 116px" }}>
                  <ellipse cx="142" cy="116" rx="14" ry="9" fill="#1878d0" stroke="#0848a0" strokeWidth="2" />
                </g>

                <g className="qw-blnk" style={{ transformOrigin: "60px 104px", animationDelay: "0.5s" }}>
                  <circle cx="60" cy="104" r="7.5" fill="#081020" stroke="#040810" strokeWidth="1.5" />
                  <circle cx="57" cy="100" r="2.4" fill="white" opacity="0.9" />
                </g>
                <g className="qw-blnk" style={{ transformOrigin: "100px 104px", animationDelay: "0.65s" }}>
                  <circle cx="100" cy="104" r="7.5" fill="#081020" stroke="#040810" strokeWidth="1.5" />
                  <circle cx="97" cy="100" r="2.4" fill="white" opacity="0.9" />
                </g>

                <path d="M54,122 Q80,142 106,122" fill="none" stroke="#081020" strokeWidth="2.5" strokeLinecap="round" />

                <circle cx="22" cy="104" r="4" fill="none" stroke="rgba(160,225,255,0.6)" strokeWidth="1.3" />
                <circle cx="16" cy="92" r="2.5" fill="none" stroke="rgba(160,225,255,0.4)" strokeWidth="1" />
                <circle cx="12" cy="82" r="1.5" fill="none" stroke="rgba(160,225,255,0.3)" strokeWidth="0.9" />
              </g>
            </g>
          </svg>
        )}
      </div>

      {/* Text content */}
      <div className="qw-text-wrap">
        <div className="qw-tilde-row">
          <span className="qw-tilde">~</span>
          <span className="qw-line-wheel">{title}</span>
          <span className="qw-tilde">~</span>
        </div>
        {showSubtitle && (
          <>
            <div className="qw-line-of">· of ·</div>
            <div className="qw-line-fortune">{subtitle}</div>
          </>
        )}
      </div>
    </div>
  );
}

export default TitleBanner;
